import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Table,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  Button,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap"
import Paginations from "components/Common/Paginations"
import { useLocation, useNavigate } from "react-router-dom"
import Filters from "components/Common/Filters"
import { useDispatch } from "react-redux"
import {
  deleteCustomer,
  getAllCustomers,
  getAppVersions,
  updateCustomerStatus,
} from "store/actions/customersAction"
import { useSelector } from "react-redux"
import Spinners from "components/Shared/Spinners"
import Switch from "components/Shared/Switch"
import SweatAlert from "components/Shared/SweatAlert"
import { showAlert } from "store/reducers/alertReducer"
import DownloadExcel from "components/Shared/DownloadExcel"
import DownloadCSV from "components/Shared/DownloadCSV"
import DownloadPDF from "components/Shared/DownloadPDF"
import {
  commonItemPerPage,
  getPerPageOptions,
  pageSizes,
  todayDate,
} from "components/Common/constants"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import isPermissionEnabled from "common/isPermissionEnabled"
import TableShimmer from "components/Shared/TableShimmer"
import { exportData } from "store/actions/commonAction"
import DownloadXLSX from "components/Shared/DownloadXLSX"
import DeleteModal from "components/Common/DeleteModal"
import formatDateTime from "components/Shared/formatDateTime"
import { pdfDownload, post } from "helpers/api_helper"
import { EXPORT_DATA } from "helpers/url_helper"
import { useTranslation } from "react-i18next"
import { setItemsPerPage } from "store/reducers/customersReducer"

const Customers = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Customers List | Namq")

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()

  const searchParams = new URLSearchParams(location.search)
  const page = parseInt(searchParams.get("page")) || 1
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  // const [appVersion, setAppVersion] = useState("")
  const [selectedId, setSelectedId] = useState(null)
  const { appVersions } = useSelector(state => state.Customers)
  const [selectedFilters, setSelectedFilters] = useState({
    status: parseInt(searchParams.get("status") || "-1"),
    sortOrder: parseInt(searchParams.get("sortOrder") || "1"),
    gender: [],
    loginType: [],
    ageRange: {},
    platform: [],
    appVersion: "",
  })

  const {
    loading,
    error,
    isLoading,
    isUpdating,
    message,
    actionType,
    customersList,
    totalCount,
    totalPages,
    currentPage,
    itemsPerPage,
  } = useSelector(state => state.Customers)

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [isApiCalled, setIsApiCalled] = useState(false)
  const flatpickrRef = useRef(null)
  const minDate = searchParams.get("minDate")
  const maxDate = searchParams.get("maxDate")

  const [dateRange, setDateRange] = useState({
    // min: todayDate,
    // max: todayDate,
  })
  const [ageRange, setAgeRange] = useState({
    min: null,
    max: null,
  })
  const [tempAgeRange, setTempAgeRange] = useState({
    min: "",
    max: "",
  })

  useEffect(() => {
    // if (searchParams.size === 0) {
    getAllCustomersList()
    // } else {
    //   setIsApiCalled(true)
    // }
  }, [])

  const { userRole, accountType, authUser } = useSelector(state => state.Login)

  const [customersPermissions, setCustomersPermissions] = useState({
    list: null,
    edit: null,
    delete: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      7,
      "customersPermission_1",
      accountType
    )

    const isPermissionEdit = isPermissionEnabled(
      userRole,
      7,
      "customersPermission_2",
      accountType
    )

    const isPermissionDelete = isPermissionEnabled(
      userRole,
      7,
      "customersPermission_4",
      accountType
    )

    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setCustomersPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole])

  const filters = [
    // {
    //   name: "status",
    //   type: "select",
    //   options: [
    //     { label: t("All"), value: -1 },
    //     { label: t("Active"), value: 1 },
    //     { label: t("Deactive"), value: 0 },
    //   ],
    //   placeholder: t("All"),
    // },
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: t("Ascending"),
    },
    {
      name: "gender",
      type: "multiSelect",
      options: [
        { label: t("Male"), value: "Male" },
        { label: t("Female"), value: "Female" },
      ],
      placeholder: t("Gender"),
    },
    {
      name: "loginType",
      type: "multiSelect",
      options: [
        { label: t("Google"), value: "GOOGLE" },
        // { label: t("Facebook"), value: "FACEBOOK" },
        { label: t("Apple"), value: "APPLE" },
        {
          label: t("Phone Number"),
          value: "PHONE_NUMBER_AND_PASSWORD",
        },
      ],
      placeholder: t("Login Type"),
    },
    {
      name: "platform",
      type: "multiSelect",
      options: [
        { label: t("Android"), value: "Android" },
        { label: t("iOS"), value: "iOS" },
      ],
      placeholder: t("Platform"),
    },
  ]

  if (selectedFilters?.platform?.length > 0) {
    filters.push({
      name: "appVersion",
      type: "select",
      options: appVersions.map(item => ({
        label: item,
        value: item,
      })),
      placeholder: t("App Versions"),
    })
  }

  const getAllCustomersList = () => {
    const { status, sortOrder, gender, loginType, appVersion, platform } =
      selectedFilters
    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: status, // 0 deactive, 1 active, 2 for all
      orderBy: sortOrder,
      keyword: searchTerm,
      appVersion: platform?.length > 0 ? appVersion : "",
      dateRange:
        dateRange.min && dateRange.max
          ? { min: dateRange.min, max: dateRange.max }
          : {},
    }
    dispatch(getAllCustomers(payload))
    setIsApiCalled(true)
  }

  useEffect(() => {
    const { platform } = selectedFilters
    if (platform?.length > 0) {
      fetchAppVersions()
    }
  }, [selectedFilters])

  const fetchAppVersions = () => {
    const { platform } = selectedFilters
    const updatedPlatform = platform?.map(item => item.value) || []
    const transformedPlatform = updatedPlatform?.map(item =>
      item === "android" ? "Android" : item
    )
    const payload = { platform: transformedPlatform }
    dispatch(getAppVersions(payload))
  }

  const formatAgeRange = ageRange => {
    const { min, max } = ageRange
    if (min !== null && max !== null) {
      return { min, max }
    }
    return {}
  }

  const handleFetchCustomers = (page = 1) => {
    const { status, sortOrder, gender, loginType, platform, appVersion } =
      selectedFilters
    const updatedGender = gender?.map(item => item.value) || []
    const updatedLoginType = loginType?.map(item => item.value) || []
    const updatedPlatform = platform?.map(item => item.value) || []
    const searchParams = new URLSearchParams()
    if (searchTerm) searchParams.set("search", searchTerm)
    searchParams.set("status", status.toString())
    searchParams.set("sortOrder", sortOrder.toString())
    searchParams.set("page", page.toString())
    if (dateRange.min) searchParams.set("minDate", dateRange.min.toString())
    if (dateRange.max) searchParams.set("maxDate", dateRange.max.toString())

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status),
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
      appVersion: platform?.length > 0 ? appVersion : "",
      gender: updatedGender,
      loginType: updatedLoginType,
      ageRange: formatAgeRange(ageRange),
      platform: updatedPlatform,
      dateRange:
        dateRange.min && dateRange.max
          ? { min: dateRange.min, max: dateRange.max }
          : {},
    }

    dispatch(getAllCustomers(payload))
      .then(action => {
        const { statusCode, status } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/customers?${searchParams.toString()}`)
        }
      })
      .catch(error => {
        // Handle error if needed
      })
  }

  const handleSearch = () => {
    handleFetchCustomers(1)
  }

  const onPageChange = page => {
    handleFetchCustomers(page)
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const handleAppVersionChange = e => {
    // setAppVersion(e.target.value)
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     if (searchTerm) {
  //       const delayDebounceFn = setTimeout(() => {
  //         handleSearch()
  //       }, 500)

  //       return () => clearTimeout(delayDebounceFn)
  //     } else {
  //       handleSearch()
  //     }
  //   }
  // }, [searchTerm, selectedFilters, isApiCalled, itemsPerPage])

  // useEffect(() => {
  //   if (dateRange.min && dateRange.max) {
  //     handleSearch()
  //   }
  // }, [dateRange])
  // useEffect(() => {
  //   if (ageRange.min && ageRange.max) {
  //     handleSearch()
  //   }
  // }, [ageRange])

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => {
      const updatedFilters = {
        ...prevFilters,
        [filterName]: selectedValue,
      }

      if (filterName === "platform" && selectedValue.length === 0) {
        updatedFilters.appVersion = "" // Reset appVersion if platform is cleared
      }

      return updatedFilters
    })
  }

  const handleReset = () => {
    // setDateRange({ min: todayDate, max: todayDate })
    setAgeRange({})
    setTempAgeRange({
      min: "",
      max: "",
    })
    setSelectedFilters({
      status: -1,
      sortOrder: 1,
      gender: [],
      loginType: [],
      ageRange: {},
      platform: [],
      appVersion: "",
    })
    dispatch(setItemsPerPage(50))
    setSearchTerm("")
    const payload = {
      perPage: 50,
      pageNo: 1,
      status: -1, // 0 deactive, 1 active, -1 for all
      orderBy: 1,
      keyword: "",
      gender: [],
      loginType: [],
      platform: [],
      ageRange: {},
      dateRange: {},
    }
    dispatch(getAllCustomers(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          navigate(`/customers?page=1`)
        }
      })
      .catch(error => {})

    if (flatpickrRef.current) {
      flatpickrRef.current.flatpickr.clear()
    }
    // if (flatpickrRef.current) {
    //   flatpickrRef.current.flatpickr.setDate([todayDate, todayDate])
    // }
  }

  const handleEnableCustomer = (id, status) => {
    const payload = {
      id,
      status: status === 1 ? "0" : "1",
    }
    dispatch(updateCustomerStatus(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleExcelDownload = async () => {
    const { status, sortOrder } = selectedFilters

    // DownloadExcel(formattedData, filename)
    const payload = {
      status: Number(status),
      keyword: searchTerm || "",
      type: "CUSTOMER",
      exportType: "xlsx",
      dateRange:
        dateRange.min && dateRange.max
          ? { min: dateRange.min, max: dateRange.max }
          : {},
    }
    const response = await post(EXPORT_DATA, payload)
    if (response) {
      // const xlsxData = response
      // DownloadXLSX(xlsxData, t("Customers"))
      const { statusCode, status, msg } = response
      if (statusCode === 200 && status) {
        dispatch(showAlert({ text: msg, type: "success" }))
      } else {
        dispatch(showAlert({ text: msg, type: "error" }))
      }
    }
  }

  const exportToCSV = async () => {
    const { status, sortOrder, gender, loginType, platform } = selectedFilters
    const updatedGender = gender?.map(item => item.value) || []
    const updatedLoginType = loginType?.map(item => item.value) || []
    const updatedPlatform = platform?.map(item => item.value) || []
    const payload = {
      status: Number(status),
      keyword: searchTerm || "",
      type: "CUSTOMER",
      exportType: "csv",
      gender: updatedGender,
      loginType: updatedLoginType,
      platform: updatedPlatform,
      ageRange: formatAgeRange(ageRange),
      dateRange:
        dateRange.min && dateRange.max
          ? { min: dateRange.min, max: dateRange.max }
          : {},
    }

    const response = await post(EXPORT_DATA, payload)
    if (response) {
      // const csvData = response
      // DownloadCSV(csvData, t("Customers"))
      const { statusCode, status, msg } = response
      if (statusCode === 200 && status) {
        dispatch(showAlert({ text: msg, type: "success" }))
      } else {
        dispatch(showAlert({ text: msg, type: "error" }))
      }
    }
  }

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // 2 FOR DELETE
    }
    dispatch(deleteCustomer(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowDeleteModal(false)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const perPageOptions = getPerPageOptions(totalCount)

  const handlePerPageChange = e => {
    dispatch(setItemsPerPage(Number(e.target.value)))
  }

  return (
    <div className="page-content  customers_page">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                // onDownloadPDF={handleDownloadPDF}
                onDownloadCSV={exportToCSV}
                isXLSX={false}
                // onDownloadExcel={handleExcelDownload}
                cardTitle={t("Customers List")}
                isExportData={loading ? false : authUser?.allowExports}
                isCustomPage={true}
                perPageOptions={perPageOptions}
                itemsPerPage={itemsPerPage}
                handlePerPageChange={handlePerPageChange}
              />
              <CardBody>
                {/* {!loading && ( */}
                <Filters
                  filters={filters}
                  searchTerm={searchTerm}
                  handleSearchChange={handleSearchChange}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  handleReset={handleReset}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                  isCustomPageSize={true}
                  pageSizes={pageSizes}
                  searchBy={t("Name, Phone Number")}
                  isRangeDate={true}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  flatpickrRef={flatpickrRef}
                  colSize={3}
                  isAgeRange={true}
                  ageRange={ageRange}
                  setAgeRange={setAgeRange}
                  tempAgeRange={tempAgeRange}
                  setTempAgeRange={setTempAgeRange}
                />
                {/* )} */}
                <div className="">
                  {loading ? (
                    <TableShimmer row={7} col={9} />
                  ) : customersList.length === 0 ? (
                    <p className="text-center my-3">
                      {t("No customers found")}
                    </p>
                  ) : (
                    <Table className="table mb-0" hover>
                      <thead className="table-light full_th">
                        <tr>
                          <th>{t("S. No.")}</th>
                          <th>{t("Name")}</th>
                          <th>{t("Phone Number")}</th>
                          <th>{t("Platform")}</th>
                          <th>{t("Gender")}</th>
                          <th>{t("Age")}</th>
                          <th>{t("Login Type")}</th>
                          {/* <th>{t("Total Orders")}</th> */}
                          {/* <th>{t("Amount Spent")}</th> */}
                          {/* <th>{t("Loyalty Points")}</th> */}
                          {/* <th>{t("Last Orders Date")}</th> */}
                          <th>{t("Join Date")}</th>
                          {/* <th>{t("Status")}</th> */}
                          <th>{t("Action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {customersList.map(
                          (
                            {
                              _id,
                              name,
                              phone,
                              loginType,
                              status,
                              gender,
                              age,
                              createdAt,
                              platform,
                              appVersion,
                            },
                            index
                          ) => (
                            <tr
                              key={index}
                              onClick={() =>
                                navigate(
                                  `/customers/customer-details?id=${_id}`
                                )
                              }
                              className="cursor-pointer"
                            >
                              <td scope="row">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td>{name || "-"}</td>
                              <td>{phone || "-"}</td>
                              <td>
                                {platform || "-"}
                                {appVersion && ` (${appVersion})`}
                              </td>

                              {/* <td>{appVersion || "-"}</td> */}
                              <td>{t(gender) || "-"}</td>
                              <td>{age ?? "-"}</td>
                              <td>
                                {loginType === "GOOGLE"
                                  ? t("Google")
                                  : loginType === "FACEBOOK"
                                  ? t("Facebook")
                                  : loginType === "APPLE"
                                  ? t("Apple")
                                  : loginType === "PHONE_NUMBER_AND_PASSWORD"
                                  ? t("Phone Number")
                                  : "-"}
                              </td>
                              {/* <td>{ordersCount}</td> */}
                              {/* <td>{totalAmount} SAR</td> */}
                              {/* <td>{totalPoints}</td> */}
                              {/* <td>
                                {formatDateTime(lastOrder?.orderDate) || "-"}
                              </td> */}
                              <td>{formatDateTime(createdAt) || "-"}</td>

                              {/* <td>
                                {status === 1 ? (
                                  <Badge className="bg-success">
                                    {t("Active")}
                                  </Badge>
                                ) : (
                                  <Badge className="bg-danger">
                                    {t("Deactive")}
                                  </Badge>
                                )}
                              </td> */}
                              <td>
                                <div className="d-flex gap-2">
                                  <div className="d-flex">
                                    {/* {customersPermissions.edit && (
                                      <Switch
                                        onClickHandler={e => {
                                          e.stopPropagation()
                                          handleEnableCustomer(_id, status)
                                          setSelectedId(_id)
                                        }}
                                        isChecked={status}
                                        disabled={
                                          _id === selectedId && isUpdating
                                        }
                                      />
                                    )} */}
                                    <UncontrolledDropdown>
                                      <DropdownToggle
                                        tag="a"
                                        className="card-drop"
                                        onClick={e => e.stopPropagation()}
                                      >
                                        <i className="mdi mdi-dots-vertical font-size-18"></i>
                                      </DropdownToggle>
                                      <DropdownMenu className="dropdown-menu-end">
                                        {customersPermissions.edit && (
                                          <DropdownItem
                                            onClick={e => {
                                              e.stopPropagation()
                                              navigate(
                                                `/customers/edit?id=${_id}`
                                              )
                                            }}
                                          >
                                            <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                                            {t("Edit")}
                                          </DropdownItem>
                                        )}

                                        <DropdownItem
                                          onClick={e => {
                                            e.stopPropagation()
                                            navigate(
                                              `/customers/customer-details?id=${_id}`
                                            )
                                          }}
                                        >
                                          <i className="mdi mdi-eye font-size-16 text-primary me-1"></i>
                                          {t("View")}
                                        </DropdownItem>

                                        {customersPermissions.delete && (
                                          <DropdownItem
                                            onClick={e => {
                                              e.stopPropagation()
                                              setItemIdToDelete(_id)
                                              setShowDeleteModal(true)
                                            }}
                                          >
                                            <i className="mdi mdi-trash-can font-size-16 text-danger me-1"></i>
                                            {t("Delete")}
                                          </DropdownItem>
                                        )}
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                </div>
                {!loading && customersList.length > 0 && (
                  <div className="mt-3">
                    <Paginations
                      data={customersList}
                      itemsPerPage={itemsPerPage}
                      onPageChange={onPageChange}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <DeleteModal
        show={showDeleteModal}
        isLoading={isLoading}
        onDeleteClick={handleDelete}
        onCloseClick={() => setShowDeleteModal(false)}
        buttonText={t("Delete")}
        bodyTitle={t(
          "Are you sure you want to delete this customer?"
        )}
      />
    </div>
  )
}

export default Customers
